import { ApiStatus } from '../../types';

import {
    RepaymentAEM,
    repaymentDefaultAEM,
    RepaymentEndpoints,
    RepaymentState,
} from './repaymentTypes';

export const initialStateRepayment: RepaymentState = {
    content: repaymentDefaultAEM,
    getRepaymentApiStatus: ApiStatus.Idle,
    apiEndpoints: { getRepaymentUrl: '/getRepayment', saveRepaymentUrl: '/saveRepayment' },
    repaymentAccounts: [],
    submitRepaymentApiStatus: ApiStatus.Idle,
};

export const getRepaymentPreloadData = (
    content: RepaymentAEM,
    apiEndpoints: RepaymentEndpoints,
): RepaymentState => ({
    ...initialStateRepayment, content, apiEndpoints,
});
